export default "__VITE_ASSET__BKJ05Kqn__"